import cn from 'classnames';

import styles from './SliderLoader.module.scss';

export const SliderLoader = ({ className }: { className?: string }) => (
  <div className={cn(styles['slider-loader'], className)} />
);
